import { render } from "./FrmBoxReadingsPalletizing.vue?vue&type=template&id=1c0d6f36"
import script from "./FrmBoxReadingsPalletizing.vue?vue&type=script&lang=js"
export * from "./FrmBoxReadingsPalletizing.vue?vue&type=script&lang=js"

import "./FrmBoxReadingsPalletizing.vue?vue&type=style&index=0&id=1c0d6f36&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__